import { companyWithBusinessDescriptionFullDescription } from '../../../../shared/entities/view/components/view-grid/constants/viewGridCustomColumnsSettings';

export const favouritesIposCustomColumnsSettings = [companyWithBusinessDescriptionFullDescription];
